export interface ICommand { }

export class CreatePortfolioCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.CreatePortfolioCommandV1, TCh.Domain.Quest'

	StrategyWorkspaceId: number
	PortfolioWorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string

	constructor (strategyWorkspaceId: number, portfolioWorkspaceId: number, strategyId: string, id: string, name: string, description: string)
	{
		this.StrategyWorkspaceId = strategyWorkspaceId
		this.PortfolioWorkspaceId = portfolioWorkspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.CreatePortfolioCommandV1, TCh.Domain.Quest'
	}

}

export class DeletePortfolioCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.DeletePortfolioCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string

	constructor (workspaceId: number, id: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.DeletePortfolioCommandV1, TCh.Domain.Quest'
	}

}

export class ExportAllActiveProjectPlansCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.ExportAllActiveProjectPlansCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string

	constructor (workspaceId: number, id: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.ExportAllActiveProjectPlansCommandV1, TCh.Domain.Quest'
	}

}

export class ImportProjectPlansFromSpreadsheetCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.ImportProjectPlansFromSpreadsheetCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	BlobId: string
	ImportedPlanName: string

	constructor (workspaceId: number, id: string, blobId: string, importedPlanName: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.BlobId = blobId
		this.ImportedPlanName = importedPlanName
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.ImportProjectPlansFromSpreadsheetCommandV1, TCh.Domain.Quest'
	}

}

export class LinkPortfolioCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.LinkPortfolioCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	PortfolioWorkspaceId: number
	PortfolioTchProjectId: number

	constructor (workspaceId: number, strategyId: string, id: string, portfolioWorkspaceId: number, portfolioTchProjectId: number)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.PortfolioWorkspaceId = portfolioWorkspaceId
		this.PortfolioTchProjectId = portfolioTchProjectId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.LinkPortfolioCommandV1, TCh.Domain.Quest'
	}

}

export class SaveViewAllProjectsPageCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.SaveViewAllProjectsPageCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	Grid: string

	constructor (workspaceId: number, id: string, grid: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.Grid = grid
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.SaveViewAllProjectsPageCommandV1, TCh.Domain.Quest'
	}

}

export class SaveViewFinishedProjectsPageCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.SaveViewFinishedProjectsPageCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	Grid: string

	constructor (workspaceId: number, id: string, grid: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.Grid = grid
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.SaveViewFinishedProjectsPageCommandV1, TCh.Domain.Quest'
	}

}

export class SaveViewOwnerProjectsPageCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.SaveViewOwnerProjectsPageCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	Grid: string

	constructor (workspaceId: number, id: string, grid: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.Grid = grid
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.SaveViewOwnerProjectsPageCommandV1, TCh.Domain.Quest'
	}

}

export class SaveViewProposedProjectsPageCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.SaveViewProposedProjectsPageCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	Grid: string

	constructor (workspaceId: number, id: string, grid: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.Grid = grid
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.SaveViewProposedProjectsPageCommandV1, TCh.Domain.Quest'
	}

}

export class SaveViewScheduledProjectsPageCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.SaveViewScheduledProjectsPageCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	Grid: string

	constructor (workspaceId: number, id: string, grid: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.Grid = grid
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.SaveViewScheduledProjectsPageCommandV1, TCh.Domain.Quest'
	}

}

export class SaveViewStartedProjectsPageCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.SaveViewStartedProjectsPageCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	Grid: string

	constructor (workspaceId: number, id: string, grid: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.Grid = grid
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.SaveViewStartedProjectsPageCommandV1, TCh.Domain.Quest'
	}

}

export class UpdatePortfolioSettingsCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.UpdatePortfolioSettingsCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	Name: string
	Description: string
	BenefitsConfidenceDate: any | null
	ExcludedResourceIds: any
	ExcludedRevenueIds: any
	ExcludedExpenseIds: any
	ExcludedCapexIds: any

	constructor (workspaceId: number, id: string, name: string, description: string, benefitsConfidenceDate: any | null, excludedResourceIds: any, excludedRevenueIds: any, excludedExpenseIds: any, excludedCapexIds: any)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.Name = name
		this.Description = description
		this.BenefitsConfidenceDate = benefitsConfidenceDate
		this.ExcludedResourceIds = excludedResourceIds
		this.ExcludedRevenueIds = excludedRevenueIds
		this.ExcludedExpenseIds = excludedExpenseIds
		this.ExcludedCapexIds = excludedCapexIds
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.UpdatePortfolioSettingsCommandV1, TCh.Domain.Quest'
	}

}

